import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import actions from "../../context/actions/actions";
import { notify } from "../../libraries/notifications";
import Button from "../../components/commons/Button";
import { history } from "../../routes";
import Loader from "../../components/commons/Loader";
import config from "../../config";
import { CardOnboarding } from "./FlowStep1";
import IconPoints from "../../components/customs/IconPoints";
import imgCelebration from "../../assets/img/stars-flow.png";
import Icon from "../../libraries/icons";
import tooltip_impact from "../../assets/img/puntos-impacto-circle.png";


class FlowStep5 extends Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.id = this.props.match.params.id;
    this.idFlow = this.props.match.params.idFlow;
    this.currentUrl = this.props.location?.pathname;
    this.state = {
      challenge: null,
      appMode: this.props?.mode_app_settings?.item?.value || "normal"
    };
  }


  getFlow() {
    const flowsSelectedMode = config.FLOWS[this.state.appMode] ?? config.FLOWS["normal"]
    const flow = flowsSelectedMode.find(f => f.id == this.idFlow)
    if (flow) this.setState({ flow: flow, challenge: flow?.challenge, action: flow?.challenge?.json_data.action }, () => this.getAction(flow.action.id))
  }


  async getAction(id) {
    await this.props.onGetAction({ id: id });
    const error = this.props.action.error;
    if (error) {
      notify(error);
    } else {
      this.setState({ action: this.props.action.item });
    }
  }

  componentDidMount() {
    this.getFlow();
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps?.mode_app_settings?.item?.value !== this.props?.mode_app_settings?.item?.value && this.state.appMode !== this.props.mode_app_settings?.item?.value)) {
      this.setState({ appMode: this.props.mode_app_settings?.item?.value })
    }
    if (prevState.appMode !== this.state.appMode) {
      this.getFlow();
    }
  }


  async saveChallenge() {
    history.push(config.ROUTES.HOME)
  }

  render() {
    return (
      <main className="h-full text-center ">
        {this.props.action.loading && <Loader />}
        {this.state.challenge &&
          <CardOnboarding>
            <div className="h-80 md:h-72 flex flex-col items-center w-full p-8 mt-28">
              <div class="dropdown dropdown-hover dropdown-bottom dropdown-end absolute top-5 right-5 z-10">
                <div className="rounded-full text-white w-5 h-5 grid">
                  <Icon className="h-5 w-5 text-gray-400 hover:text-primary" name={"question"} color={"#B3B3B3"} />
                  <div tabindex="0" class="dropdown-content z-[2] card card-compact p-3 w-[20rem] mt-2 pr-3 shadow-xl bg-base-200 bg-transparent-90 text-neutral-content mb-2">
                    <h3 class="card-title text-base-content text-sm mb-4">Puntos de Impacto</h3>
                    <div class="flex items-start ">
                      <div class="w-8 h-8  flex-shrink-0 absolute top-1 right-1">
                        <img src={tooltip_impact} alt="puntos" />
                      </div>
                      <div class="text-xs text-left space-y-2 text-base-content">
                        <p className="text-xs">Se acumulan (no se gastan).
Los ganas al realizar acciones, prestar o pedir prestado.
Definen tu nivel, tu posición en el ranking y los premios a los que puedes acceder.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-80 md:h-96 flex items-center justify-center absolute top-10 left-0 w-full">
                <img className="max-w-[100%]" src={imgCelebration} alt="" width={"200%"} />
              </div>
              {this.state.action?.json_data.points && this.state.action?.json_data.coins && <div className="mx-auto">
                <IconPoints iconClassName="h-30 my-1 text-success" color='' className="py-4 px-2 flex flex-col items-center justify-center gap-0 rounded text-2xl text-success bg-transparent" points={this.state.action?.json_data.points} leyend={'Pts Impacto'} numberClassName={'text-base-content text-4xl font-bold mt-1'} />
              </div>}
            </div>
            <span>
              <h1 className="text-base-content text-2xl mb-5">
                {this.t("¡Ganaste!")}
              </h1>
              {/* <p className="text-gray-600 mb-16">{this.t(this.state.action.name)}</p> */}
            </span>
            <div className="p-8">
              <Button
                className="btn-block btn-primary mt-10"
                title={this.t("Ir a Nuestro Muro").toUpperCase()}
                onClick={() => this.saveChallenge()}
              />
            </div>
          </CardOnboarding>
        }
      </main>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.users.auth.user,
    action: state.actions.current,
    transaction: state.transactions.current,
    mode_app_settings: state.settings.appmode,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onGetAction: (params) => dispatch(actions.get(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(FlowStep5));
